import React from 'react'

import { FiArrowLeft, FiBell } from 'react-icons/fi'
import { Link, useHistory } from 'react-router-dom'
import { Container } from './styles'
import { useQuery } from '@shared/hooks/query'

import Image from '@shared/components/Image'
import PropTypes from 'prop-types'
import avatarImage from '@shared/assets/user.png'
import { useAuth } from '@shared/hooks/auth'
import { Column, Row } from '@shared/components/Layout'
import { maskPhone } from '@shared/utils/textMask'
import themes from '@config/themes'

const Header = ({ title, info, goBackTo, navigateBack, items }) => {
  document.title = `${title} · Paggue Gestão`

  const { unit, user } = useAuth()
  const { getQueryParams } = useQuery()
  const { from } = getQueryParams()

  const history = useHistory()

  const goToPreviousPath = () => {
    history.goBack()
  }

  React.useEffect(() => {
    document.title = `${title}`
  })

  const pageInfo = React.useMemo(() => {
    if (info) {
      return info
    }

    if (items.total > 0) {
      return `Exibindo ${items.displayed} / ${items.total}`
    }

    return ''
  }, [info, items])

  return (
    <>
      <Container>
        <div className="header__navigation">
          <div className="header__title-container">
            <span className="header__caption">{pageInfo}</span>
          </div>

          <div className="header__title-container">
            {(goBackTo || navigateBack) &&
              (navigateBack ? (
                <a
                  href="#"
                  className="header__goback"
                  onClick={goToPreviousPath}>
                  <FiArrowLeft />
                </a>
              ) : (
                <Link className="header__goback" to={from || goBackTo}>
                  <FiArrowLeft />
                </Link>
              ))}
            <h1 className="header__title">
              <span className="to-print">{unit?.name} · </span>
              {title}
            </h1>
          </div>
        </div>
        <div className="header__actions">
          <div className="header__icon">
            <FiBell />
          </div>

          <Link className="header__avatar" to="/profile">
            <Image src={avatarImage} alt="Jimmy Bastos" />
          </Link>
        </div>

        {unit?.address && (
          <div className="to-print" style={styles.printInfo}>
            <Row $justifyEnd>
              <Column xs={8}>
                <small>
                  <p style={styles.info}>
                    <b>Endereço: </b>
                    {`${unit.address.street},
                    N° ${unit.address.house_number},
                    ${unit.address.neighborhood},
                    ${unit.address.city?.name || ''} - ${
                      unit.address.state?.code || ''
                    },
                  CEP ${unit.address.zip_code}`}
                  </p>
                </small>
              </Column>
              <Column xs={4}>
                <small>
                  <p style={styles.info}>
                    <b>Telefone: </b>
                    {maskPhone(user.phone)}
                  </p>
                </small>
              </Column>
            </Row>
          </div>
        )}
      </Container>
    </>
  )
}

const styles = {
  printInfo: {
    width: '100%',
    marginBottom: '72px',
    color: themes.default.heading
  }
}

Header.defaultProps = {
  info: '',
  goBackTo: null,
  navigateBack: false,
  items: {}
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string,
  goBackTo: PropTypes.string,
  items: PropTypes.object,
  navigateBack: PropTypes.bool
}

export default Header
